import React from 'react'

const Fifth_pane = () => {
  return (
    <div className='uk-container uk-margin-large-top'>
        <div>
            <div className='uk-width-1-1' data-uk-grid>
          

             

                <h2  className='light uk-text-bold'>Join the Moolu Venture Lab Movement</h2>
                <p className='light'>If you are a visionary founder working on an innovative tech startup that aligns with our mission, 
                    we invite you to join the Moolu Venture Lab Movement. </p>

           
            </div>
    </div>
    </div>
  )
}

export default Fifth_pane